module.exports = __webpack_public_path__ + "static/media/emma-stone-icon.5a68358a.jpg";